<template>
  <landing-page label="factSheet.diabetesMellitus" labelColor="#603813" descColor="#603813" :eggImgObj="{ componentName: 'factsheet', imgName: 'diabetesMellitus', imgFormat: 'png' }" :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconLightBrownRight', imgFormat: 'svg' }" />

  <div id="infoGroup" style="width: 60vw" class="fact-sheet-subpages pt-16 text-2xl font-jost space-y-12 m-auto pb-24">
    <div v-html="t('factSheet.diabetesMellitusContent')" />
    <br />
    <div v-html="t('factSheetChinese.diabetesMellitusContent')" class="!font-sanstc" />
  </div>
</template>

<script setup lang="ts">
import { useFactSheetStore } from "@/stores/factSheet";
import { useHeaderStore } from "@/stores/header";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const factSheetStore = useFactSheetStore();
const headerStore = useHeaderStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {
  headerStore.routerName = 'factsheet';
});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>